import * as React from "react";
import { useEffect, useState } from "react";

import { ModalComponent } from "shared/components/modal/modal";
import { AddressTypeEnum, IAddressModel, ICreatedCustomerAddressModel, ICustomerAddressModel } from "states/customer-address/customer-address.models";
import { getCountriesAPI } from "states/address/address.api";
import { ICountryModel } from "states/address/address.models";
import { useAppDispatch } from "app.hook";
import { setLoading, showError } from "states/global-value/global-value.slice";
import { createdCustomerAddressesAPI } from "states/customer-address/customer-address.api";
import { fetchCustomerAddresses } from "states/customer-address/customer-address.slice";
import { IconAddress } from "themes";

export const AddBillingAddress = () => {
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [countries, setCountries] = useState<ICountryModel[]>([]);
  const [model, setModel] = useState<ICustomerAddressModel>({} as ICustomerAddressModel);
  const dispatch = useAppDispatch();
  const handleOpenModal = () => {
    setIsOpen(true);
  };
  const handleCloseModal = () => {
    setIsOpen(false);
  };
  const _handleSubmitAddress = async () =>{
    dispatch(setLoading(true));
    try{
      let payload = {
        ...model,
        addressType: AddressTypeEnum.Billing
      } as ICreatedCustomerAddressModel;
      await createdCustomerAddressesAPI(payload);
      dispatch(fetchCustomerAddresses());
      handleCloseModal();
      dispatch(setLoading(false));
    }catch(err){
      dispatch(setLoading(false));
      dispatch(showError(err?.response?.data?.error?.message))
    }
  }
  useEffect(() => {
    setModel({
      addressInfo:{ } as IAddressModel,
    } as ICustomerAddressModel);
  },[modalIsOpen])
  useEffect(() => {
    getCountriesAPI().then((address) => {
      setCountries(address.data);
    })

  }, []);

  return (
    <React.Fragment>
      <button onClick={handleOpenModal} className="btn--primary flex uppercase  px-3 py-1">
        <IconAddress width={20} className="mr-1 fill-img-white text-white" /> <span> Add address </span>
      </button>
      <ModalComponent
        width={`100%`}
        height={`100%`}
        isModal={false}
        className="w-full bg-white rounded-2xl"
        isCustomizeFooter={true}
        onCloseModal={handleCloseModal}
        isOpenModal={modalIsOpen}
        title={`Add Address`}
      >
        <div className="p-3">
          <div className="form-group mb-2">
            <input
              value={model.addressInfo?.firstName}
              placeholder="Please enter first name"
              className="rounded-md px-3 py-3 w-full border border-gray-300"
              onChange={(ev) => {
                setModel({ ...model, 
                  addressInfo:{
                  ...model.addressInfo,
                  firstName: ev.target.value
                }});
              }}
            />
          </div>
          <div className="form-group mb-2">
            <input
              value={model.addressInfo?.lastName}
              placeholder="Please enter last name"
              className="rounded-md px-3 py-3 w-full border border-gray-300"
              onChange={(ev) => {
                setModel({ ...model, 
                  addressInfo:{
                    ...model.addressInfo,
                    lastName: ev.target.value
                 }});
              }}
            />
          </div>
          <div className="form-group mb-2">
            <input
              value={model.addressInfo?.phoneNumber}
              placeholder="Please enter phone Number"
              className="rounded-md px-3 py-3 w-full border border-gray-300"
              onChange={(ev) => {
                setModel({ ...model,  addressInfo:{
                  ...model.addressInfo,
                  phoneNumber: ev.target.value
               } });
              }}
            />
          </div>
          <div className="form-group mb-2">
            <select value={model.addressInfo?.countryCode} className="w-full border border-gray-300 rounded-md px-3 py-3 mb-2" onChange={(ev) => {
              setModel({ ...model, addressInfo:{
                ...model.addressInfo,
                countryCode: ev.target.value,stateCode:""
              } });
            }}>
              <option value={``}>--- Select Country ---</option>
              {countries?.map((m) => (<option key={m.countryCode} value={m.countryCode}>{m.name}</option>))}
            </select>
          </div>
          <div className="form-group mb-2">
            <select value={model.addressInfo?.stateCode} placeholder="Select State" className="w-full border border-gray-300 rounded-md px-3 py-3 mb-2" onChange={(ev) => {
              setModel({ ...model, addressInfo:{
                ...model.addressInfo,
                stateCode: ev.target.value
              } });
            }}>
              <option value={``}>--- Select State ---</option>
              {countries?.find(m => m.countryCode === model?.addressInfo?.countryCode)?.states?.map((m) => (<option key={m.stateCode} value={m.stateCode}>{m.name}</option>))}
            </select>
          </div>
          <div className="form-group mb-2">
            <input
              value={model.addressInfo?.provinceName}
              placeholder="Please enter city"
              className="rounded-md px-3 py-3 w-full border border-gray-300"
              onChange={(ev) => {
                setModel({ ...model, addressInfo:{
                  ...model.addressInfo,
                  provinceName: ev.target.value
                } });
              }}
            />
          </div>
          <div className="form-group mb-2">
            <input
              value={model.addressInfo?.street}
              placeholder="Please enter address"
              className="rounded-md px-3 py-3 w-full border border-gray-300"
              onChange={(ev) => {
                setModel({ ...model, addressInfo:{
                  ...model.addressInfo,
                  street: ev.target.value
                } });
              }}
            />
          </div>
          <div className="form-group mb-2">
            <input
              value={model.addressInfo?.postalCode}
              placeholder="Please enter postal code"
              className="rounded-md px-3 py-3 w-full border border-gray-300"
              onChange={(ev) => {
                setModel({ ...model, addressInfo:{
                  ...model.addressInfo,
                  postalCode: ev.target.value
                } });
              }}
            />
          </div>
        </div>
        <button
           onClick={_handleSubmitAddress}
            className="btn--primary w-full px-8 py-2 uppercase font-semibold"
          >
            Confirm
       </button>
      </ModalComponent>
    </React.Fragment>
  );
};
